import { getLocationFriendlyName, TicketStockIcon } from './TicketStockProperty';
import { Center, Group, Text } from '@mantine/core';
import { BrokerNerdsBarkerCoreEnumsTicketStock } from '../../../api';

export function TicketStockDisplay({ ticketStockId }: { ticketStockId: BrokerNerdsBarkerCoreEnumsTicketStock }) {
  const friendlyName = getLocationFriendlyName(ticketStockId);

  return (
    <Group wrap="nowrap" gap={4}>
      <Text lh={1.25} pt={2}>
        {friendlyName}
      </Text>
      <Center style={{ flexShrink: 0 }}>
        <TicketStockIcon ticketStockId={ticketStockId} color="var(--colors-iconFill)" size={16} />
      </Center>
    </Group>
  );
}
